const Vue = window.Vue

Vue.component('AvailableInstallmentPlans', () => import('./components/AvailableInstallmentPlans.vue'))
